// client/src/pages/Admin/ProjectManager/components/ProjectEmptyState.tsx
/**
 * PROJECT EMPTY STATE COMPONENT
 * 
 * Displayed when no projects are found.
 * 
 * @module ProjectManager/Components/ProjectEmptyState
 */

import React from 'react';
import { FolderOpen, Plus, Lightbulb } from 'lucide-react';

interface ProjectEmptyStateProps {
    hasActiveFilters: boolean;
    onNewProject: () => void;
}

export const ProjectEmptyState: React.FC<ProjectEmptyStateProps> = ({
    hasActiveFilters,
    onNewProject
}) => {
    return (
        <div className="no-projects">
            <div className="empty-icon" aria-hidden="true"><FolderOpen size={36} /></div>
            <h3>
                {hasActiveFilters 
                    ? 'No projects match your filters'
                    : 'No projects yet'}
            </h3>
            <p>
                {hasActiveFilters
                    ? 'Try adjusting your search or filter criteria'
                    : 'Create your first project to get started'}
            </p>
            {!hasActiveFilters && (
                <button
                    className="btn-primary"
                    onClick={onNewProject}
                    aria-label="Create your first project"
                >
                    <Plus size={16} />
                    Create Project
                </button>
            )}
            {hasActiveFilters && (
                <p className="hint">
                    <Lightbulb size={14} />
                    Tip: Clear filters to see all projects
                </p>
            )}
        </div>
    );
};